import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import EventOrganizerEditDialog from "@/components/Events/EventOrganizerEditDialog/EventOrganizerEditDialog.vue";

import { createOpLoc, updateOpLoc, defaultOpLoc } from "@/helpers/opLocHelper";
import "./EventBaseData.scss";
export default {
  name: "EventBaseData",
  props: [
    "errorList",
    "editedEvent",
    "step",
    "position",
    "categoryGroups",
    "organizer",
    "locations",
    "groupedOrganizer",
    "groupedLocations",
    "isOwnedBySubPrincipal"
  ],
  data: () => ({
    requireLocation: true,
    locationRules: [
      value =>
        !!value ||
        "Bitte wählen Sie einen Standort aus oder geben diesen unter Zusatzinformation an!"
    ],
    previewOpLocDialog: false,
    previewOpLocTypes: {
      Operator: "Veranstalter",
      Location: "Standort"
    },
    selectedPreviewOpLocType: null,
    showCreateOpLocDialog: false,
    editedOpLoc: {
      ...defaultOpLoc
    }
  }),
  mounted() {
    if (this.editedEvent.location) this.requireLocation = false;
    this.importerLocationWorkaround();
  },
  methods: {
    createOpLoc,
    updateOpLoc,
    importerLocationWorkaround() {
      if (this.editedEvent?.tramino_id || this.editedEvent?.feratel_id) {
        this.requireLocation = false;
      }
    },
    updateValue(value) {
      if (Array.isArray(value)) value = value[0];
      this.editedEvent.category = value;
    },
    updateOperator(value) {
      if (Array.isArray(value) && value[0]) value = value[0];
      else value = "";
      this.operator = value;
      this.editedEvent.operator = this.operator;
    },
    updateLocation(value) {
      if (Array.isArray(value)) value = value[0];
      this.location = value;
      this.editedEvent.location = this.location;
      if (this.editedEvent.location) this.requireLocation = false;
      if (this.editedEvent.location.length === 0) {
        this.editedEvent.location = null;
        this.requireLocation = true;
      }
      this.importerLocationWorkaround();
    },
    showPreviewOpLocDialog(type) {
      this.selectedPreviewOpLocType = type;
      this.previewOpLocDialog = true;
    },
    async saveOpLoc(closeDialog) {
      try {
        let response = null;
        if (this.editedOpLoc?.geo && !this.editedOpLoc?.geo?.type) {
          this.editedOpLoc.geo.type = "Point";
        }

        if (this.editedOpLoc._id) {
          response = await this.updateOpLoc(this.editedOpLoc);
        } else {
          response = await this.createOpLoc(this.editedOpLoc);
        }

        if (response.status === 200 || response.status === 201) {
          this.editedOpLoc = response?.data;

          if (this.editedOpLoc.type.includes("operator")) {
            this.updateOperator([this.editedOpLoc._id]);
          }
          if (this.editedOpLoc.type.includes("location")) {
            this.updateLocation([this.editedOpLoc._id]);
          }

          await this.$store.dispatch(
            "createSuccess",
            "Element wurde erfolgreich angelegt"
          );
        }

        if (closeDialog) {
          await this.closeCreateOpLocDialog();
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    openCreateOpLocDialog(type) {
      this.$refs.eventOrganizerEditDialog?.$refs?.editForm?.reset();
      this.editedOpLoc.type = [type];
      this.showCreateOpLocDialog = true;
    },
    async closeCreateOpLocDialog() {
      this.$refs.eventOrganizerEditDialog?.$refs?.editForm?.reset();
      this.editedOpLoc = { ...defaultOpLoc };
      this.showCreateOpLocDialog = false;
      this.$nextTick(
        async () => await this.$store.dispatch("getOrganizer", { filter: {} })
      );
    }
  },
  computed: {
    operator: {
      get() {
        return this.editedEvent?.operator ?? [];
      },
      set(value) {
        this.editedEvent.operator = value;
      }
    },
    location: {
      get() {
        return this.editedEvent?.location ?? [];
      },
      set(value) {
        this.editedEvent.location = value;
      }
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    oplocs() {
      return this.$store.state.oplocs;
    },
    cPreviewOpLoc() {
      if (!this.selectedPreviewOpLocType) {
        return;
      }
      if (this.selectedPreviewOpLocType === this.previewOpLocTypes.Operator) {
        return this.oplocs.find(opLoc => opLoc._id === this.operator);
      }
      if (this.selectedPreviewOpLocType === this.previewOpLocTypes.Location) {
        return this.oplocs.find(opLoc => opLoc._id === this.location);
      }
    },
    showPreviewOpLocCoordinates() {
      return this.cPreviewOpLoc?.geo?.coordinates.every(c => !!c);
    },
    users() {
      return this.$store.state.users;
    },
    config() {
      return this.$store.state.eventConfig;
    }
  },
  components: { EventOrganizerEditDialog, TreeViewSelection }
};
